import React, { useRef } from "react";
import classes from "./SchoolsContainer.module.css";
import iyte from "../../images/Iyte.jpg";
import ifl from "../../images/IFL.jpg";
import { useState } from "react";
import { useEffect } from "react";

const SchoolsContainer = (props) => {
  const [animating, setAnimating] = useState(false);

  const schoolsContainerRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Add a class to the component when it enters the viewport
          setAnimating(true);
        }
      });
    });

    observer.observe(schoolsContainerRef.current);
  }, []);
  return (
    <div
      className={`${classes.schoolsContainer} + ${
        animating ? classes.animate : null
      }`}
      ref={schoolsContainerRef}
    >
      <div className={classes.schoolCard}>
        <img src={iyte} className={classes.logo} />
        <div className={classes.textContainer}>
          <h4 className={classes.cardTitle}>
            İzmir Yüksek Teknoloji Enstitüsü - Computer Engineering (2018-2023)
          </h4>
          <p>
            The İzmir Institute of Technology (IZTECH) is a Turkish state
            university established in 1992 to offer higher education and carry
            out research in the fields of science and technology. The medium of
            instruction at our institute is English. We are currently the only
            internationally distinguished advanced technical university in
            Turkey.
          </p>
        </div>
      </div>
      <div className={classes.schoolCard}>
        <img src={ifl} className={classes.logo} />
        <div className={classes.textContainer}>
          <h4 className={classes.cardTitle}>İzmir Fen Lisesi (2013 - 2017)</h4>
          <p>
            İzmir Fen Lisesi is a top high school in Izmir, Turkey, established
            in 1983. It is known for its strong focus on science, math, and
            technology. The school has excellent teachers and a tough curriculum
            that helps students think critically and solve problems. It offers
            extracurricular activities, research opportunities, and
            competitions. Its reputation shows its commitment to academic
            excellence.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolsContainer;
